import React, { useState } from "react";
import { useAuth } from "../AuthContext";
import api from "../api";

export default function Dashboard() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ amount: "", description: "" });

  const handleTopUp = async (e) => {
    e.preventDefault();
    setLoading(true);

    const generatedRef = "TXN" + Date.now();

    const payload = {
      amount: Number(formData.amount),
      externalRef: generatedRef,
      remarks: formData.description || "Topup balance",
      redirectUrl: "https://sms.ditechsc.com/dashboard",
      type: "TOPUP",
    };

    try {
      const res = await api.post("/orders/checkout", payload);

      if (res.data?.paymentUrl) {
        window.location.href = res.data.paymentUrl;
      } else {
        alert("Top-up request submitted successfully!");
        setIsModalOpen(false);
        setFormData({ amount: "", description: "" });
      }
    } catch (err) {
      console.error("Top-up Error Detail:", err.response?.data || err.message);

      // Check for 401 Unauthorized - Token might be missing
      if (err.response?.status === 401) {
        alert("Session expired. Please login again.");
      } else {
        alert(err.response?.data?.message || "Failed to process top-up");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid gap-6 md:grid-cols-2">
      <div className="bg-white p-6 rounded shadow relative">
        <h2 className="text-lg font-semibold">Account</h2>
        <p className="mt-2">
          <strong>{user?.name}</strong>
        </p>
        <p className="text-sm text-gray-500">
          {user?.username} • {user?.mobile}
        </p>

        <div className="mt-4 flex items-center justify-between bg-emerald-50 p-4 rounded-lg">
          <div>
            <div className="text-sm text-gray-500">Balance</div>
            <div className="text-2xl font-bold text-emerald-700">
              ETB {Number(user?.balance || 0).toFixed(2)}
            </div>
          </div>

          {/* Top Up Icon/Button */}
          <button
            onClick={() => setIsModalOpen(true)}
            className="p-2 bg-emerald-600 text-white rounded-full hover:bg-emerald-700 shadow-md transition-all"
            title="Fund Balance"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 4v16m8-8H4"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="bg-white p-6 rounded shadow">
        <h2 className="text-lg font-semibold">Quick Actions</h2>
        <div className="mt-4 grid gap-3">
          <a
            href="/send-sms"
            className="block p-3 rounded border hover:shadow hover:bg-gray-50 transition-colors"
          >
            Send SMS
          </a>
          <a
            href="/report"
            className="block p-3 rounded border hover:shadow hover:bg-gray-50 transition-colors"
          >
            View Reports
          </a>
        </div>
      </div>

      {/* TOP UP MODAL */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
            <div className="p-6 border-b flex justify-between items-center">
              <h3 className="text-xl font-bold text-gray-800">Fund Balance</h3>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleTopUp} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-1">
                  Amount (ETB)
                </label>
                <input
                  type="number"
                  required
                  placeholder="0.00"
                  className="w-full border rounded-lg p-3 outline-none focus:ring-2 focus:ring-emerald-500"
                  value={formData.amount}
                  onChange={(e) =>
                    setFormData({ ...formData, amount: e.target.value })
                  }
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-600 mb-1">
                  Description
                </label>
                <textarea
                  placeholder="Reference or reason"
                  className="w-full border rounded-lg p-3 outline-none focus:ring-2 focus:ring-emerald-500"
                  rows="3"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-emerald-600 text-white py-3 rounded-lg font-bold hover:bg-emerald-700 disabled:opacity-50 transition-colors"
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
